import { useState, useEffect } from "react";
import Button from "../../components/button";
import CardContainer from "../../components/card_container";
import Input from "../../components/input";
import TextArea from "../../components/text_area";
import InputImage from "../../components/input_image";
import InputSwitch from "../../components/input_switch";
import Select from "../../components/select";
import "./fabric.scss";
import UseFormFabric from "./hookForm";
import LoadingModal from "../../components/loading_modal";
import { axios } from "../../helpers";
import { useSelector } from "react-redux";
import { loginData } from "../../stores/auth";

const AddFabricsPage = () => {
  const {
    isLoading,
    form,
    formData,
    isOn,
    handleSwitch,
    handleChange,
    handleImageChange,
    handleSubmit,
  } = UseFormFabric({
    type: "post",
  });

  let [product, setProduct] = useState([]);
  const dataLogin = useSelector(loginData);
  const getProduct = async () => {
    await axios
      .get("/v1/fabric/product", {
        headers: { Authorization: `Bearer ${dataLogin.data.token}` },
      })
      .then((res) => {
        let tmp = [];
        res.data.data.map((item) => {
          tmp.push({ value: item._id, label: item.name });
        });
        setProduct([{ value: "", label: "-- Select Product --" }, ...tmp]);
      });
  };
  useEffect(() => {
    getProduct();
  }, []);
  return (
    <>
      <CardContainer
        title={"Add Data"}
        isBack={true}
        children={
          <form className="" onSubmit={handleSubmit}>
            <div className="form-fabric">
              <div className="expanded-y">
                <Input
                  style={{ width: "100%" }}
                  id="fabric_name"
                  onChange={handleChange}
                  label="Fabric Name"
                  placeholder="Input fabric name"
                  required={true}
                />
                <Input
                  style={{ width: "100%" }}
                  id="brand"
                  onChange={handleChange}
                  label="Brand"
                  placeholder="Input brand fabric"
                  required={true}
                />
                <Input
                  style={{ width: "100%" }}
                  id="stock_code"
                  onChange={handleChange}
                  label="Stock Code"
                  placeholder="Input stock code"
                  required={true}
                />
                <Input
                  style={{ width: "100%" }}
                  id="pattern"
                  onChange={handleChange}
                  label="Pattern"
                  placeholder="Input pattern"
                  required={true}
                />
                <Input
                  style={{ width: "100%" }}
                  id="color"
                  onChange={handleChange}
                  label="Color"
                  placeholder="Input color"
                  required={true}
                />
                <Input
                  style={{ width: "100%" }}
                  id="material"
                  onChange={handleChange}
                  label="Material"
                  placeholder="Ex: cotton, silk, flanel, etc"
                  required={true}
                />
                <Select
                  label="Product"
                  id="product"
                  value={form.product}
                  onChange={handleChange}
                  required={true}
                  options={product}
                  style={{ width: "100%" }}
                />
                <Input
                  style={{ width: "100%" }}
                  id="price"
                  onChange={handleChange}
                  label="Price"
                  placeholder="Input Price"
                  type="number"
                  min={0}
                  // required={true}
                />
                <TextArea
                  style={{ width: "100%" }}
                  id="description"
                  onChange={handleChange}
                  label="Description"
                  placeholder="Input Description"
                  // required={true}
                />

                {/* <Input
                  style={{ width: "100%" }}
                  id="type"
                  onChange={handleChange}
                  label="Type"
                  placeholder="Ex: shirt,batik,suit,vest"
                  required={true}
                /> */}
                <InputImage
                  style={{ width: "100%" }}
                  id="image"
                  label={"Fabric Image"}
                  onChange={handleImageChange}
                  required={true}
                />
                <InputSwitch
                  id="status"
                  label={"Status"}
                  isOn={isOn}
                  onClick={() => handleSwitch("")}
                />
              </div>
              <hr style={{ width: "100%" }} />
              <div className="footer-forms">
                <Button
                  type="button"
                  className="btn-outline-primary"
                  style={{ marginRight: "8px" }}
                  title="Cancel"
                  onClick={() => window.history.back()}
                />
                <Button type="submit" className="btn-primary" title="Save" />
              </div>
            </div>
          </form>
        }
      />
      <LoadingModal isLoading={isLoading} />
    </>
  );
};
export default AddFabricsPage;
